(function () {
    'use strict';

    /*
     ProductAllReviewsController
    -------------------------------------------------------------------------- */

    angular
        .module('ManageProductApp.allProductReviews', [])
        .controller('ProductAllReviewsController', [
            '$scope',
            '__DataStore',
            'appServices',
            '$stateParams',
            '__Utils',
            ProductAllReviewsController
        ]);

    /**
      * ProductAllReviewsController for manage product image list
      *
      * @inject $scope
      * @inject __DataStore
      * @inject appServices
      * @inject $stateParams
      * 
      * @return void
      *-------------------------------------------------------- */

    function ProductAllReviewsController($scope, __DataStore, appServices,
        $stateParams, __Utils) {

        var scope = this;
        scope.productID = __globals.getAppJSItem('productID');

        // product reviews pagination data start
        this.showPaginationData = function (page) {
            var requestURL = '';

            if (!_.isEmpty(page) && page.search("http") != -1) {

                requestURL = page;

            } else {

                requestURL = __Utils.apiURL('product.user.all_review.paginate_data',
                    {
                        'productId': scope.productID
                    }
                );

                var pageUrl = "";

                if (page != undefined) {
                    pageUrl = "?page=" + page;
                }

                requestURL = requestURL + pageUrl;

            }


            __DataStore.fetch(requestURL, { 'fresh': true })
                .success(function (responseData) {
                    var requestData = responseData.data;

                    appServices.processResponse(responseData, null, function (reactionCode) {
                        scope.productReviews = requestData.productReviewData;

                        scope.paginationLinks = requestData.paginationLinks;

                        if (scope.paginationLinks) {
                            var $paginationLinksElement = $(".lw-pagination-container").html(scope.paginationLinks);
                        }
                    });
                });

        };

        this.showPaginationData('');
        $(".lw-pagination-container").on('click', 'a', function (event) {
            event.preventDefault();
            var $this = $(this),
                url = $this.attr('href');
            scope.showPaginationData(url);
        });
        // product reviews pagination data stop
    };

})();